<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/14i8maN/tc-custom/9783968657639.jpg?1703128391005" alt="This image is the cover for the book Amazing Stories Volume 42, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Amazing Stories Volume 42, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>Amazing Stories Volume 42 is a great collection of action short stories from "The Golden Age of Science Fiction". Featured here are four stories by Robert Ray Cummings: "The Flame Breathers", "Juggernaut of Space", "The Little Monsters Come", and "Ordeal in Space".</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ray Cummings
      </h2>
      
      <p class="authorDescription body article">Ray Cummings (born Raymond King Cummings) (August 30, 1887 – January 23, 1957) was an American author of science fiction literature and comic books. Cummings is identified as one of the "founding fathers" of the science fiction genre. His most highly regarded fictional work was the novel The Girl in the Golden Atom published in 1922, which was a consolidation of a short story by the same name published in 1919 (where Cummings combined the idea of Fitz James O'Brien's The Diamond Lens with H. G. Wells's The Time Machine) and a sequel, The People of the Golden Atom, published in 1920.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f87bb6c2